import { environment } from '../../../../../environments/environment';
import { StorageManager } from '../../../../common/storage-manager.class';

export class TareasBioEnvironmentDefinition {
    public readonly appName = environment.appName;
    public readonly serverUrl = environment.serverUrl;
    public readonly logoUrl = environment.logoUrl;
    public readonly hasClients = environment.features.hasClients;
    public readonly clienteName = environment.features.clienteName;
    public readonly userCanSeeClientes = environment.features.userCanSeeClientes;
    public readonly canSeeClientes = this.hasClients && (
        this.userCanSeeClientes ? true : StorageManager.getUser().rol === 'admin'
    );
    public readonly fincaName = environment.features.fincaName;
    public readonly sectorName = environment.features.sectorName;
    public readonly parcelasName = environment.features.parcelasName;
    public readonly showTareasParcela = environment.features.showTareasParcela;
    public readonly showBioMotivo = environment.features.showBioMotivo;
    public readonly showBioOrden = environment.features.showBioOrden;
    public readonly showGenerateRecetaBio = environment.features.showGenerateRecetaBio;
    public readonly showTareasBioSectorMultiple = environment.features.showTareasBioSectorMultiple;
    public readonly showTareasBioParcelaMultiple = environment.features.showTareasBioParcelaMultiple;
    public readonly timeStartStopTareas = environment.features.timeStartStopTareas;
    public readonly tareasHorasTotales = environment.features.tareasHorasTotales;
    public readonly horaFechaFinActualPorDefecto = environment.features.horaFechaFinActualPorDefecto;
}
